<template>
  <div>
    <OverlayPanel
      :ref="'op'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 700px"
    >
      <Button style="float: left;" label="View Customer" icon="pi pi-search" @click="viewCustomer"/>
      <Button style="float: right;" label="View Full History" icon="pi pi-inbox" @click="viewFullHistory"/>
      <br />
      <br />
      <HistoryTable
        :data="customerHistory"
        :name="'Customer History'"
        :loading="customerHistoryLoading"
        :customer="tempCustomer"
      />
    </OverlayPanel>

    <OverlayPanel
      :ref="'opActions'"
      @click="toggle"
      appendTo="body"
      :showCloseIcon="true"
      id="overlay_panel"
      style="width: 250px;"
      :baseZIndex=-10
    >
      <div style="padding: 0px 1px">
        <div class="row" style="background-color: white;">
          <div class="p-field p-col"
            v-for="(obj, index) in getActionButtons1()" 
            :key="index"
            style="margin: 0px; text-align: center; padding: 0px;"
          >
            <Button 
              :label="obj.label" 
              :icon="obj.icon"
              :disabled="obj.disabled ? obj.disabled : false"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
        <hr />
        <div class="row" style="background-color: white;">
          <div class="col col-lg-12 col-md-12">
            <Button 
              v-for="(obj, index) in actionButtons2" 
              :key="index" 
              :label="obj.label" 
              :icon="obj.icon"
              class="p-button-text p-button-plain" 
              @click="runFunction(obj)"
            />
          </div>
        </div>
      </div>
    </OverlayPanel>

    <DataTable
      :key="tableKey"
      :value="quotations"
      :paginator="true"
      class="p-datatable-striped p-datatable-sm p-datatable-gridlines p-datatable-customers"
      dataKey="quoteVerId"
      :rowHover="true"
      :selection.sync="selectedQuotations"
      :loading="loading"
      paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
      :rowsPerPageOptions="[25, 50, 100]"
      currentPageReportTemplate="{first} to {last} of {totalRecords} Quotations"
      :resizableColumns="true" 
      columnResizeMode="expand"
      @column-resize-end="colsResized"
      :reorderableColumns="false" 
      @column-reorder="colReordered"
      @page="onPage($event)"
      :lazy="true"
      :totalRecords="totalRecords"
      @sort="onSort($event)"
      :sortField="tableSortField"
      :sortOrder="defaultSortOrder"
      :first="defaultFirstPage"
      :rows="defaultRows"
      @row-click="rowClicked($event)"
      contextMenu
      :contextMenuSelection.sync="selectedRow"
      @row-contextmenu="onRowContextMenu"
      :scrollable="true"
      scrollHeight="400px"
      frozenWidth="50px"
    >
      <template #empty> No quotations found. </template>
      <template #loading> Loading quotations data. Please wait. </template>
      <div
        :key="columnsKey"
      >
        <!-- <Column selectionMode="multiple" headerStyle="width: 3em"></Column> -->
        <Column 
          header="Actions"
          headerStyle="width: 50px; height: 30px; padding: 10px 0px;"
          :frozen="true"
        >
          <template #body="slotProps">
            <div  
              style="height: 40px; padding: 10px 0px; display: flex; align-items: center;"
            >
              <Button 
                icon="pi pi-ellipsis-v" 
                class="p-button-rounded p-button-text"
                @click="toggleActions($event, slotProps.data)"
              />
            </div>
          </template>
        </Column>
        <Column 
          v-for="(col, index) of colSelectedFieldsForTable" 
          :key="col.dbField + '_' + index"
          :field="getOptionLabel(col)[0]" 
          :sortField="sortKeyOf(col, colSelectedFieldsForTable)"
          :header="col.fieldName" 
          :sortable="true"
          :headerStyle="'width: ' + col.defWidth + 'px; height: 41px;'"
        >
          <template #body="slotProps">
            <div
              style="height: 40px; padding: 10px 0px;"
              @click="openOP(slotProps.data, col, $event)"
              :class="getStyle1(slotProps.data, col)"
            >
              {{ getToShow(slotProps.data, col) }}
            </div>
          </template>
        </Column>
        <Column 
          field="statusName" 
          headerStyle="width: 9em;" 
          header="Status" 
          :sortable="true"
        >
          <template #body="slotProps">
            <span 
              v-on:click="changeStatus(slotProps.data)"
              :class="'ignore pointer badge ' + getStyle(slotProps.data.quoteStatus)" 
            >
              {{ slotProps.data.quoteStatus && slotProps.data.quoteStatus.statusName ? slotProps.data.quoteStatus.statusName : '' }}
            </span>
                  
            <OverlayPanel 
              ref="statuses" 
              appendTo="body" 
              :showCloseIcon="true" 
              id="statuses" 
              style="width: 130px"
            > 
              <div
                v-for="(val, index) in tempQuoteStatuses"
                :key="index"
              >
                <span 
                  @click="updateStatus(val)" 
                  :class="'ignore pointer badge ' + getStyle(val)" 
                >
                  {{ val.statusName }}
                </span>
                <br />
                <br />
              </div>
            </OverlayPanel>
            <!-- <span :class="'customer-badge status-' + getStyle(slotProps.data.activityStatus.statusName)" style="font-size: 18px;">{{ slotProps.data.activityStatus.statusName }}</span> -->
            <!-- <span :class="'customer-badge status-RENEWAL'" style="font-size: 18px;">{{ slotProps.data.activityStatus.statusName }}</span> -->
            <!-- <Badge value="slotProps.data.activityStatus.statusName" severity="danger"></Badge> -->
          </template>
        </Column>
        <!-- <Column 
          headerStyle="width: 10em;"
        >
          <template #body="slotProps">
            <div
              class="splitButtonColumn"
              :style="{position: 'absolute'}"
            >
              <SplitButton 
                label="View" 
                icon="pi pi-info" 
                @click="infoPage(slotProps.data)" 
                :model="getButtons(slotProps.data)"
              >
              </SplitButton>
            </div>
          </template>
        </Column> -->
      </div>
    </DataTable>

    <div class="flex justify_space_between my-1">
      <div>
        Page Totals are
        &nbsp;
        {{ pageTotal }}
      </div>
      <div 
        style="width: 185px; display: flex; justify-content: flex-end;" 
      >
        <ProgressSpinner
          v-if="makingExport"
          style="width:100%; height:25px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Export all data to excel"
          icon="pi pi-external-link"
          @click="$emit('exportData')"
        />
      </div>
    </div>

    <ContextMenu :model="getButtons(selectedRow)" ref="cm" />

    <CommentBox
      :reload="reloadCommentBox"
      :commentDialog="commentDialog"
      label="Please give details below"
      :sendingRequest="sendingRequest"
      @close="commentDialog = false"
      @save="addComment"
    />

    <WonDialog
      :reload="reloadWonDialog"
      :wonDialog="wonDialog"
      label="Enter PO/Order Details:"
      :sendingRequest="sendingRequest"
      @close="wonDialog = false"
      @save="addWonDetails"
    />

    <LostStatusDialog
      :reload="reloadLostStatusBox"
      :lostDialog="lostDialog"
      :sendingRequest="sendingRequest"
      @close="lostDialog = false"
      @save="addLost"
    />

    <ExpiryDateDialog
      :reload="reloadExpiryDateBox"
      :expiryDateDialog="expiryDateDialog"
      :sendingRequest="sendingRequest"
      @close="expiryDateDialog = false"
      @save="addExpriyDate"
    />

    <Dialog header="Confirmation" :visible.sync="displayConfirmation" :style="{width: '350px'}" :modal="true">
      <div class="confirmation-content">
        <i class="pi pi-exclamation-triangle p-mr-3" style="font-size: 2rem" />
        <span>Are you sure you want to proceed?</span>
      </div>
      <template #footer>
        <Button label="No" icon="pi pi-times" @click="displayConfirmation = false" class="p-button-text"/>
        <Button label="Yes" icon="pi pi-check" @click="confirmDelete" class="p-button-text" autofocus />
      </template>
    </Dialog>

  </div>
</template>
<script>
import { columnSortKey, sortChangeFor, restoreSortKey } from '@/mbp/universalComponents/listSort'
import { formatCurrency } from '@/utils/money'
import QuotationService from "@/service/QuotationService"
import FiltersService from "@/service/FiltersSerice"
import CustomerService from "@/service/CustomerService"
import AttachmentService from "@/service/AttachmentService"

import CommentBox from './CommentBox'
import WonDialog from './WonDialog'
import LostStatusDialog from './LostStatusDialog'
import ExpiryDateDialog from './ExpiryDateDialog'
import HistoryTable from '../customer/customerHistoryTable'

import {
  quotationRequest,
  columnSelectionRequest
} from '../sendRequest'

export default {
  components: {
    CommentBox,
    WonDialog,
    LostStatusDialog,
    ExpiryDateDialog,
    HistoryTable,
    // Badge
  },
  props: [
    "dbView",
    "quotations", 
    "loading", 
    "colSelectedFieldsForTable", 
    "colSelectedFields", 
    "dbViewFields", 
    'totalRecords',
    'rows',
    'currentPage',
    'reloadTable',
    'makingExport'
  ],
  data: () => ({
    quotationService: new QuotationService(),
    filtersService: new FiltersService(),
    customerService: new CustomerService(),
    attachmentService: new AttachmentService(),
    selectedQuotations: [],
    selectedRow: null,
    quoteStatuses: [],
    quotation: {},
    opportunity: {},
    selected: [],
    tempQuoteStatuses: [],
    tempCustomer: {},
    
    previousPage: null,
    scheduleDialog: false,
    reloadScheduleDialog: 0,
    tableKey1: 0,
    columnsKey1: 0,
    defaultSortField: '',
    defaultSortFieldId: null,
    defaultSortOrder: 0,
    defaultFirstPage: 1,
    defaultRows: 25,
    sendingRequest: false,

    customerHistory: [],
    customerHistoryLoading: false,
    expiryDateDialog: false,
    reloadExpiryDateBox: 0,
    commentDialog: false,
    wonDialog: false,
    file: {},
    reloadCommentBox: 0,
    reloadWonDialog: 0,
    lostDialog: false,
    reloadLostStatusBox: 0,

    actionButtons2: [
      {
        label: 'Duplicate',
        icon: 'pi pi-copy',
        command: (that) => {
          that.$emit('duplicateQuote', that.selectedRow)
        }
      },
      {
        label: 'View Quotation Verions',
        icon: 'pi pi-money-bill',
        command: (that) => {
          that.viewQuotations(that.selectedRow)
        }
      },
      {
        label: 'View Tasks & Events',
        icon: 'pi pi-calendar',
        command: (that) => {
          that.viewActivities(that.selectedRow)
        }
      },
      {
        label: 'View Attachments',
        icon: 'pi pi-file',
        command: (that) => {
          that.viewAttachments(that.selectedRow)
        }
      },
      {
        label: 'View History',
        icon: 'pi pi-inbox',
        command: (that) => {
          that.viewHistory(that.selectedRow)
        }
      }
    ],

    pageTotal: 0,
    displayConfirmation: false,
  }),
  created() {
    
    this.setupComponent()
    
    this.quotationService
      .getAllActiveQuotationStatuses()
      .then(data => this.quoteStatuses = data)
      .catch(err => {
        
              
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while quotation statuses",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activeQuoteStatuses"'
        })
      })
  },
  mounted() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)

    this.calculatePageTotals()
  },
  updated() {
    setTimeout(() => {
      this.setSplitButtonLocations()
    }, 100)
  },
  computed: {
    /** C2: the saved sort, shown on the right column when columns share a db_field last segment. */
    tableSortField() {
      return restoreSortKey(this.defaultSortField, this.defaultSortFieldId, this.colSelectedFieldsForTable)
    },
    splitButtonLocationReset() {
      return this.$store.getters.getSplitButtonLocationReset
    },
    tableKey: {
      set(val) {
        this.tableKey1++
      }, 
      get() {
        return 'tableKey-' + this.tableKey1.toString()
      }
    },
    columnsKey: {
      set(val) {
        this.columnsKey1++
      }, 
      get() {
        return 'columnKey-' + this.columnsKey1.toString()
      }
    }
  },
  watch: {
    splitButtonLocationReset(val) {
      this.setSplitButtonLocations()
    },
    rows(val) {
      this.defaultRows = val
    },
    currentPage(val) {
      this.defaultFirstPage = (val - 1) * this.defaultRows
    },
    reloadTable(val) {
      
      this.setupComponent()

      this.tableKey++
    },
    quotations(val) {
      this.columnsKey++

      this.calculatePageTotals()
    },
    selected(val) {
      
      if (val && val[0] && val[0].id) {
        this.sendingRequest = false
        this.setSplitButtonLocations()
        columnSelectionRequest(this, 'QuotationTableForLazyLoadingWithResize.vue')
      }
    },
    colSelectedFieldsForTable(val) {
      
      this.columnsKey++
      // setTimeout(() => this.colSelectedFieldsForTable.forEach(a => 
    }
  },
  methods: {
    delete(data) {
      this.displayConfirmation = true
    },
    confirmDelete() {
      this.displayConfirmation = false
      this.$emit("confirmDelete", this.selectedRow);
    },
    onRowContextMenu(event) {
      // this.$refs.cm.show(event.originalEvent);
    },
    rowClicked(event) {
      if (
        event 
        && event.originalEvent 
        && event.originalEvent.target 
        && (
          event.originalEvent.target.classList.contains("under_lined")
          ||
          event.originalEvent.target.classList.contains("ignore")
        )
      ) {
        return
      } else {
        this.infoPage(event.data)
      }
    },
    setSplitButtonLocations() {
      // getElementsByClassName gives an HTMLCollection, which has no forEach (it threw on every list load).
      let a = Array.from(document.getElementsByClassName('splitButtonColumn'))
      if (a) {
        a.forEach(div => {
          // 
          div.style.top = (div.parentElement.offsetTop + 10).toString() + 'px'
          div.style.left = (div.parentElement.offsetLeft + 10).toString() + 'px'
        })
      }
    },
    setupComponent() {
      
      
      if (this.$store.getters['quotations/getSortField']) {
        this.defaultSortField = this.$store.getters['quotations/getSortField']
        this.defaultSortOrder = this.$store.getters['quotations/getSortOrder']
        this.defaultSortFieldId = this.$store.getters['quotations/getSortFieldId']
        
      } else {
        this.defaultSortField = ''
        this.defaultSortOrder = 0
        this.defaultSortFieldId = null
      }

      this.defaultRows = this.$store.getters['quotations/getRows']
      this.defaultFirstPage = (this.$store.getters['quotations/getPage'] - 1) * this.defaultRows

    },
    async toggle(event) {
      this.$refs.op.toggle(event);
    },
    openOP(data, col, event) {
      
      
      if (data && data.customer && data.customer.customerId && event.target && event.target.className === "under_lined") {
        this.tempCustomer = data.customer
        this.customerHistory = []
        this.customerHistoryLoading = true
        this.customerService
          .getCustomerHistory(data.customer.customerId)
          .then(data => {
            if (data.length > 20) {
              this.customerHistory = data.slice(0, 20);
            } else {
              this.customerHistory = data
            }
            this.customerHistoryLoading = false
          })
          .catch(err => {
            this.customerHistoryLoading = false
            // this.$toast.add({
            //   severity: "error",
            //   summary: "Error",
            //   detail: "Error while getting customer history.",
            //   life: 5000,
            // })
            this.$store.dispatch('addErrorMessage', {
              severity: 'error',
              content: 'Some data was not loaded from "getCustomerHistory/{customerId}"'
            })
          })
        this.toggle(event);
      }
    },
    viewFullHistory() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/history",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    viewCustomer() {
      if (this.tempCustomer && this.tempCustomer.customerId)
        this.$router.push({
          path: "customers/" + this.tempCustomer.customerId + "/detail",
          params: { custid: this.tempCustomer.customerId },
        });
    },
    getKey1() {
      
      return this.columnsKey + this.columnsKey.toString()
    },
    getKey() {
      
      return ''
    },
    colReordered(event) {
      
    },
    colsResized(event) {
      
      
      if (
        event.element && 
        event.element.clientWidth &&
        event.element.textContent
      ) {
        let e = event.element.clientWidth
        

        if (this.colSelectedFields && this.colSelectedFields[0]) {
          
          let a = this.colSelectedFields.find(b => b.dbField.fieldName === event.element.textContent)
          

          this.setSplitButtonLocations()
          if (a && a.id) {
            this.filtersService
              .setUserViewColWidth(a.id, e)
              .then(data => {
                this.setSplitButtonLocations()

                this.$emit('colUpdated', {
                  id: a.id,
                  width: parseInt(e)
                })
              })
              .catch(error => {
                
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: `Error while updating column width.`,
                  life: 5000,
                })
              })
          }
        }
      }
    },
    onSort(event) {
      // C2: one sort, for the column clicked (by its own key, then its id), not every column sharing the last db_field segment
      const change = sortChangeFor(event, this.colSelectedFieldsForTable)
      if (change) this.$emit('sortChange', change)
    },
    sortKeyOf(col, cols) {
      return columnSortKey(col, cols)
    },
    onPage(event) {
      
      if (!(this.previousPage && event.page === this.previousPage.page && event.rows === this.previousPage.rows && event.pageCount === this.previousPage.totalpages)) {
        this.previousPage = {
          page: event.page + 1,
          rows: event.rows,
          totalPages: event.pageCount
        }
        this.$emit('lazyNext', this.previousPage)
      }
    },
    getOptionLabel(data){
      if (data) {
        if (data.dbNameField) {
          return [data.dbNameField]
        } else {
          return data ? data.dbField.split('.').slice(-1) : []
        }
      }
    },
    getStyle1(data, col) {
      if (
        col.dbField === 'quote.quoteVer' ||
        col.dbField === 'customer.custName'
      ) {
        return 'under_lined'
      }
    },
    numberWithCommas(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    },
    getToShow(data, col) {
      let a = col.dbField.split('.')
      // 

      let b = ''
      if (a.length > 1) {
        b = data[a[0]] ? data[a[0]][a[1]] : ''
      } else {
        b = data[col.dbField]
      }

      if (col.fieldType === "Currency" && b !== null && b !== undefined) {
        return formatCurrency(b)
      } else {
        return b
      }
    },
    infoPage(quote) {
      
      this.$router.push({
        path: "quotations/" + quote.quoteVerId + "/detail",
        params: { quoteVerId: quote.quoteVerId, quote },
      });
    },
    viewQuotations(data) {
      this.$router.push({
        path: "/quotations/" + data.quoteVerId + "/versions",
        params: { quoteVerId: data.quoteVerId },
      });
    },
    viewActivities(data) {
      this.$router.push({
        path: "/quotations/" + data.quoteVerId + "/activities",
        params: { quoteVerId: data.quoteVerId },
      });
    },
    viewAttachments(data) {
      this.$router.push({
        path: "/quotations/" + data.quoteVerId + "/attachments",
        params: { quoteVerId: data.quoteVerId },
      });
    },
    viewHistory(data) {
      this.$router.push({
        path: "/quotations/" + data.quoteVerId + "/history",
        params: { quoteVerId: data.quoteVerId },
      });
    },
    runFunction(obj) {
      this.$refs.opActions.hide();
      obj.command(this)
    },
    toggleActions(event, data) {
      this.selectedRow = data
      this.$refs.opActions.toggle(event);
    },
    getButtons(data) {
      let buttons = [
				{
					label: 'Edit',
					icon: 'pi pi-pencil',
					command: () => {
						this.$emit('editQuote', data)
					}
				},
				{
					label: 'Duplicate',
					icon: 'pi pi-copy',
					command: () => {
						this.$emit('duplicateQuote', data)
					}
        },
				{
					label: 'View Quotation Verions',
					icon: 'pi pi-money-bill',
					command: () => {
						this.viewQuotations(data)
					}
        },
				{
					label: 'View Tasks & Events',
					icon: 'pi pi-calendar',
					command: () => {
						this.viewActivities(data)
					}
        },
				{
					label: 'View Attachments',
					icon: 'pi pi-file',
					command: () => {
						this.viewAttachments(data)
					}
        },
				{
					label: 'View History',
					icon: 'pi pi-inbox',
					command: () => {
						this.viewHistory(data)
					}
        }
      ]
      return buttons
    },
    updateStatus(val) {
      
      if (this.quotation && this.quotation.quoteVerId && val.id) {

        if (val && val.statusName === "Active") {
          this.quotationService
            .setQuoteStatusActive(this.quotation.quoteVerId, this.$store.getters['auth/getMyProfile'].id)
            .then(data => {
              

              this.$refs.statuses.hide()
              this.quotation = {}
              // this.getAllQuotations()
              this.setupDefaultFilters()
            })
            .catch(err => {
              

              if (err.response.status !== 200)
                this.$toast.add({
                  severity: "error",
                  summary: "Error",
                  detail: "Unable to set quote as active.",
                  life: 5000,
                })
            })
        } else {
          this.$refs.statuses.hide()
          this.sendingRequest = false
              

          if (val.statusName === 'Cancelled') {
            this.tempObj = val
            this.commentDialog = true
            this.reloadCommentBox++

          } else if (val.statusName === 'Won') {
            this.tempObj = val
            this.wonDialog = true
            this.reloadWonDialog++
      
          } else if (val.statusName === 'Lost') {
            this.tempObj = val
            this.lostDialog = true
            this.reloadLostStatusBox++
      
          } else if (val.statusName === 'Expired') {
            this.tempObj = val
            this.expiryDateDialog = true
            this.reloadExpiryDateBox++

          } else {
            if (this.quotation.lostQuoteReason)
              this.quotation.lostQuoteReason = null
            if (this.quotation.statusComment)
              this.quotation.statusComment = null

            this.quotation.quoteStatus = val
            this.sendQuotePutRequest({
              quoteStatus: val.id
            })
          }
        }

      }
    },
    changeStatus(quotation) {
      

      this.tempQuoteStatuses = []

      // The menu depends on the quote's status only (Decision 7 A, 02/11). An expiry rule here read the
      // backend's dd/MM/yyyy text with new Date(), i.e. month first, so it was wrong both ways.
      if (quotation.quoteStatus.statusName === 'Active') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Won'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Lost'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Cancelled'))
      } else if (quotation.quoteStatus.statusName === 'Revised') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Closed'))
      } else if (quotation.quoteStatus.statusName === 'Closed') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else if (quotation.quoteStatus.statusName === 'Cancelled') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Won'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Lost'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else if (quotation.quoteStatus.statusName === 'Won') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Lost'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else if (quotation.quoteStatus.statusName === 'Lost') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Won'))
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else if (quotation.quoteStatus.statusName === 'Expired') {
        this.tempQuoteStatuses.push(this.quoteStatuses.find(a => a.statusName === 'Active'))
      } else {
        this.tempQuoteStatuses = this.quoteStatuses
      }

      

      this.quotation = {...quotation}
      this.$refs.statuses.toggle(event);
    },
    getStyle(data) {
      if (!data) {
        return ''
      } else {
        // according to: https://www.w3schools.com/bootstrap4/tryit.asp?filename=trybs_badges2&stacked=h
        if (data && data.colourCode) {
          return data.colourCode
        } else if (data && data.statusName && data.statusName.toLowerCase() === 'lost') {
          return 'badge-danger'
        } else if (data && data.statusName && data.statusName.toLowerCase() === 'active') {
          return 'badge-primary'
        } else if (data && data.statusName && data.statusName.toLowerCase() === 'won') {
          return 'badge-success'
        } else if (data && data.statusName && data.statusName.toLowerCase() === 'cancelled') {
          return 'badge-warning'
        } else if (data && data.statusName && data.statusName.toLowerCase() === 'revised') {
          return 'badge-info'
        } else if (data && data.statusName && data.statusName.toLowerCase() === 'closed') {
          return 'badge-secondary'
        } else {
          return 'badge-dark'
        }
      }
      // if (data && data.toLowerCase() === 'upcomming') {
      //   return 'NEW'
      // } else if (data && data.toLowerCase() === 'task') {
      //   return 'PROPOSAL'
      // } else if (data && data.toLowerCase() === 'overdue') {
      //   return 'UNQUALIFIED'
      // } else if (data && data.toLowerCase() === 'completed') {
      //   return 'QUALIFIED'
      // } else {
      //   return 'RENEWAL'
      // }
    },
    addExpriyDate(expiryDate) {
      this.quotation.expiryDate = expiryDate
      this.quotation.quoteStatus = this.tempObj
      
      this.sendingRequest = true
      quotationRequest(this, 'QuotationTableForLazyLoadingWithResize.vue')
      this.tempObj = {}
    },
    addLost({ reason, comment }) {
      
      this.quotation.lostQuoteReason = reason
      this.quotation.statusComment = comment
      this.quotation.quoteStatus = this.tempObj
      this.sendQuotePutRequest({
        quoteStatus: this.tempObj.id,
        lostQuoteReason: reason.id,
        statusComment: comment
      })
      this.tempObj = {}
    },
    addComment(comment) {
      this.quotation.statusComment = comment
      this.quotation.quoteStatus = this.tempObj
      this.sendQuotePutRequest({
        quoteStatus: this.tempObj.id,
        statusComment: comment
      })
      this.tempObj = {}
    },
    addWonDetails({ file, details }) {
      this.file = file
      this.quotation.statusComment = details
      this.quotation.quoteStatus = this.tempObj
  
      this.sendQuotePutRequest({
        quoteStatus: this.tempObj.id,
        statusComment: details,
        wonManufacturer: wonManufacturer
      })
      this.tempObj = {}
      
      let fileParams = {
        fileName: this.file.name,
        quotation: this.quotation.quoteVerId
      }
      this.attachmentService
        .postFile(file, fileParams)
        .then(res => {
          
          if (res && res.status === 200) {
            this.$toast.add({
              severity: "success",
              summary: res.data,
              detail: "File uploaded",
              life: 5000,
            });
          }
        })
        .catch(err => {
          

          if (err && err.response && err.response.data) {
            if (err.response.data.includes("exceeds the configured maximum")) {
              this.$toast.add({
                severity: "error",
                summary: "File too big.",
                detail: "File size exceeds the limited size.",
                life: 5000,
              });
            }
          }

        })
    },
    sendQuotePutRequest(obj) {

      this.sendingRequest = true
      this.quotationService
        .changeQuoteStatus(this.quotation.quoteVerId, obj)
        .then(data => {
          this.sendingRequest = false
          this.wonDialog = false
          this.commentDialog = false
          this.lostDialog = false
          

          this.quotation = {}
          this.$emit('reload')
        })
        .catch(err => {
          this.sendingRequest = false
          this.wonDialog = false
          this.commentDialog = false
          this.lostDialog = false
          

          if (err.response.status !== 200)
            this.$toast.add({
              severity: "error",
              summary: "Error",
              detail: "Unable to update quote status.",
              life: 5000,
            })
        })
    },
    calculatePageTotals() {
      if (this.quotations && this.quotations[0]) {
        this.pageTotal = 0
        this.quotations.forEach(item => {
          if (item.quoteQty && item.productValue) {
            this.pageTotal += item.quoteQty + item.productValue
          }
        })
        // 
      }
    },
    getActionButtons1() {
      
      var buttons = [
        {
          label: 'View',
          icon: 'pi pi-info',
          command: (that) => {
            that.infoPage(that.selectedRow)
          }
        },
        {
          label: 'Edit',
          icon: 'pi pi-pencil',
          command: (that) => {
            that.$emit('editQuote', that.selectedRow)
          }
        }
      ]
      
      if (
        this.selectedRow 
        && this.selectedRow.quoteStatus
        && this.selectedRow.quoteStatus.statusName === "Revised"
      ) {
        buttons.push({
          label: 'Delete',
          icon: 'pi pi-trash',
          command: (that) => {
            that.delete(that.selectedRow)
          }
        })
      }

      return buttons
    }
  }
};
</script>

<style scoped lang="scss">

</style>
